var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06364 0.158284C1.46622 0.704935 0.369882 1.96598 0.108299 3.55785C-0.0360996 4.43651 -0.0360996 33.5934 0.108299 34.4721C0.335841 35.8568 1.1955 36.9949 2.49157 37.6273C2.99413 37.8726 3.54597 38 4.10517 38H21.4913H38.8774C39.4366 38 39.9884 37.8726 40.491 37.6273C41.8102 36.9836 42.6706 35.8249 42.8772 34.4138C43.022 33.4254 43.0144 10.7548 42.8692 10.0859C42.728 9.43617 42.0326 8.68113 41.4239 8.51666C41.1402 8.44013 35.8868 8.40811 23.5444 8.40771L6.65577 8.40714C6.26822 8.40712 5.88584 8.31815 5.53809 8.14707C5.19367 7.97765 4.91572 7.74705 4.74019 7.48513C4.50692 7.13715 4.47077 6.9816 4.47077 6.3252C4.47077 5.66881 4.50692 5.51326 4.74019 5.16528C4.91572 4.90336 5.19367 4.67276 5.53809 4.50333C5.88584 4.33226 6.26822 4.24329 6.65578 4.24329H24.5333H41.683C42.4046 4.24329 42.9842 3.64813 42.9651 2.92673C42.9339 1.75491 42.9025 1.55753 42.6791 1.13153C42.5331 0.853048 42.2454 0.52252 41.9914 0.341393C41.7074 0.138775 41.3672 0.0296837 41.0183 0.0292812L22.5609 0.00799029C4.74973 -0.0126305 3.5357 -0.00331163 3.06364 0.158284ZM36.7314 20.4017C37.3944 20.6843 38.1776 21.5056 38.4007 22.152C38.6271 22.8078 38.6071 23.7463 38.3525 24.4181C37.7824 25.9226 35.9271 26.7365 34.3087 26.192C33.6557 25.9723 32.8217 25.1981 32.539 24.5492C31.3677 21.8611 34.0142 19.2432 36.7314 20.4017Z",
    fill: "url(#paint0_linear_1_104)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_104",
    x1: 21.5,
    y1: 17.2727,
    x2: 21.5,
    y2: 42.6061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48D1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D1CC",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4d32c74bf4b87df371bfe6bf7fb0bed3.svg";
export { ForwardRef as ReactComponent };